module.exports = __webpack_public_path__ + "img/market-watch.62fd2104.png";